module.exports = __webpack_public_path__ + "media/images/proof_links/colored/mixcloud-43414de443326389064f6320415b921e.svg";